import React, { useState, useEffect, forwardRef, useImperativeHandle, useMemo } from "react";
import { Collapse,Tooltip } from "antd";
import { baseURL } from './APIRepo'
import {
  UpOutlined,
  MinusOutlined,
  DownloadOutlined,
  PlusOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
} from "@ant-design/icons";
import Chart from "chart.js/auto";
import { Pie, Bar } from "react-chartjs-2";
import { ArcElement } from "chart.js";
import "./raktkoshDashboard.css";
import axios from "axios";
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels);


Chart.register(ArcElement);

const { Panel } = Collapse;

const Insights  = forwardRef((props, ref) => {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState({});

  console.log("from insights : ", props.stateCode);


const scode = props.stateCode;



  const JwtTkn =
    "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJEaGFpcnlhIn0.OCMcxEK6njp3J4SVfgV1HdDx3_-LiJ0QGaiqzfk1rbYFOIeCpm2A_2kcp1Pvn0iKMcrs0jZOOPDYGQN118z9ug";
  
    const text = <span>Stock update within 7 days</span>;

    const fetchData = async () => {
      try {
        const headers = {
          Authorization: JwtTkn,
          "Content-Type": "application/json",
        };
  
        const payload = {
          stateCode: scode
        };
  
        console.log("Fetch data called");
  
        const response = await axios.post(
          `${baseURL}/eRaktkoshUtilities/eraktkosh/overAllStats`,
          payload,
          { headers }
        );
  
        console.log("Response Data: ", response.data);
  
        setData(response.data);
        setLoading(false); 
  
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false); 
      }
    };
  
    useEffect(() => {
      fetchData(scode);
    }, [scode]);
  
    useImperativeHandle(ref, () => ({
      fetchData
    }));


    console.log("All state")
  

    const totalBloodCentres = data?.statsData?.[0]?.hbnumTotalBloodCentres ?? 0;
    const totalActive = data?.statsData?.[0]?.hbnumTotalActive ?? 0;
    const totalLicensed = data?.statsData?.[0]?.hbnumTotalLicensed ?? 0;
    const totalLicensedExpired = data?.statsData?.[0]?.hbnumTotalLicensedExpired ?? 0;
    const totalBsu = data?.statsData?.[0]?.hbnumTotalBsu ?? 0;
    const totalBloodCentresGovt = data?.statsData?.[0]?.hbnumTotalBloodCentresGovt ?? 0;
    const totalBloodCentresPrivate = data?.statsData?.[0]?.hbnumTotalBloodCentresPrivate ?? 0;
    const totalBloodCentresChar = data?.statsData?.[0]?.hbnumTotalBloodCentresChar ?? 0;
    const totalBloodCentresRedcross = data?.statsData?.[0]?.hbnumTotalBloodCentresRedCross ?? 0;
    const totalActiveGovt = data?.statsData?.[0]?.hbnumTotalActiveGovt ?? 0;
    const totalActivePrivate = data?.statsData?.[0]?.hbnumTotalActivePrivate ?? 0;
    const totalActiveChar = data?.statsData?.[0]?.hbnumTotalActiveChar ?? 0;
    const totalActiveRedcross = data?.statsData?.[0]?.hbnumTotalActiveRedCross ?? 0;
    const totalLicensedGovt = data?.statsData?.[0]?.hbnumTotalLicensedGovt ?? 0;
    const totalLicensedPrivate = data?.statsData?.[0]?.hbnumTotalLicensedPrivate ?? 0;
    const totalLicensedRedcross = data?.statsData?.[0]?.hbnumTotalLicensedRedCross ?? 0;
    const totalLicensedChar = data?.statsData?.[0]?.hbnumTotalLicensedChar ?? 0;
    const totalLicensedExpiredGovt = data?.statsData?.[0]?.hbnumTotalLicensedExpiredGovt ?? 0;
    const totalLicensedExpiredPrivate = data?.statsData?.[0]?.hbnumTotalLicensedExpiredPrivate ?? 0;
    const totalLicensedExpiredChar = data?.statsData?.[0]?.hbnumTotalLicensedExpiredChar ?? 0;
    const totalLicensedExpiredRedcross = data?.statsData?.[0]?.hbnumTotalLicensedExpiredRedCross ?? 0;
    const totalBsuGovt = data?.statsData?.[0]?.hbnumTotalBsuGovt ?? 0;
    const totalBsuOther = data?.statsData?.[0]?.hbnumTotalBsuOther ?? 0;
    const entryDate = data?.statsData?.[0]?.formattedEntryDate ?? 0;
    // console.log("date : ", entryDate)

    // Accessing state-wise stats data (example for the first state)
    const firstStateStats = data?.stateWiseStatsData?.[0] ?? {};
    const stateName = firstStateStats?.stateName ?? '';
    const districtName = firstStateStats?.districtName ?? '';
    const stateTotalBloodCentres = firstStateStats?.hbnumTotalBloodCentres ?? 0;
    const stateTotalActive = firstStateStats?.hbnumTotalActive ?? 0;
    const stateTotalLicensed = firstStateStats?.hbnumTotalLicensed ?? 0;
    const stateTotalLicensedExpired = firstStateStats?.hbnumTotalLicensedExpired ?? 0;
    const stateTotalBsu = firstStateStats?.hbnumTotalBsu ?? 0;


    
    
    // Accessing today's stats data (example for the first entry)
    const firstTodayStats = data?.todayStatsData?.todayStatsDonorData?.[0] ?? {};


    const todayStateName = firstTodayStats?.stateName ?? '';
    const todayDistrictName = firstTodayStats?.districtName ?? '';
    const todayDonorRegistered = firstTodayStats?.hbnumDonorRegistered ?? 0;

  


    const todayStatsBloodAvailData = data?.todayStatsData?.todayStatsBloodAvailData?.[0] ?? {};
    const stateNameGroup = todayStatsBloodAvailData?.stateName ?? null;
    const districtNameGroup = todayStatsBloodAvailData?.districtName ?? null;
    const hbnumTotalApos = todayStatsBloodAvailData?.hbnumTotalApos ?? 0;
    const hbnumTotalAneg = todayStatsBloodAvailData?.hbnumTotalAneg ?? 0;
    const hbnumTotalBpos = todayStatsBloodAvailData?.hbnumTotalBpos ?? 0;
    const hbnumTotalBneg = todayStatsBloodAvailData?.hbnumTotalBneg ?? 0;
    const hbnumTotalABpos = todayStatsBloodAvailData?.hbnumTotalABpos ?? 0;
    const hbnumTotalABneg = todayStatsBloodAvailData?.hbnumTotalABneg ?? 0;
    const hbnumTotalOpos = todayStatsBloodAvailData?.hbnumTotalOpos ?? 0;
    const hbnumTotalOneg = todayStatsBloodAvailData?.hbnumTotalOneg ?? 0;
    const hbnumTotalOHpos = todayStatsBloodAvailData?.hbnumTotalOHpos ?? 0;
    const hbnumTotalOHneg = todayStatsBloodAvailData?.hbnumTotalOHneg ?? 0;
    








    const todayStatsDonorData = data?.todayStatsData?.todayStatsDonorData ?? [];

    // Extracting data for the first state (if it exists)
    const firstDonorData = todayStatsDonorData[0] ?? {};
    const stateNameDonor = firstDonorData?.stateName ?? '';
    const districtNameDonor = firstDonorData?.districtName ?? '';
 
    const hbnumDonorRegistered = firstDonorData?.hbnumDonorRegistered ?? 0;
    





    console.log("Donor Registered data :>> ",stateNameDonor , districtNameDonor, hbnumDonorRegistered )
  sessionStorage.setItem('frtdEDt', entryDate);


  window.addEventListener('beforeunload', function () {
    sessionStorage.removeItem('frtdEDt');
});



const todayStatsBloodAvailDataComponent = data?.todayStatsData?.todayStatsBloodCompData?.[0] ?? {};


const totalPrbc = todayStatsBloodAvailDataComponent?.hbnumTotalPrbc ?? 0;
const totalFfp = todayStatsBloodAvailDataComponent?.hbnumTotalFfp ?? 0;
const totalPlatelateConc =  todayStatsBloodAvailDataComponent?.hbnumTotalPlatletConcentrate ?? 0;
const plasma =  todayStatsBloodAvailDataComponent?.hbnumTotalPlasma ?? 0;
const totalCryo = todayStatsBloodAvailDataComponent?.hbnumTotalCryo ?? 0;
const totalCpp = todayStatsBloodAvailDataComponent?.hbnumTotalCpp ?? 0;
const totalSdp = todayStatsBloodAvailDataComponent?.hbnumTotalSdp ?? 0;
const totalWb = todayStatsBloodAvailDataComponent?.hbnumTotalWb ?? 0;






  // ########################################################################################################################################

  const [dataState, setDataState] = useState({});
  const [selectData, setSelectData] = useState([]);
  const [loadingState, setLoadingState] = useState(true);


  const [showPieChart, setShowPieChart] = useState(false);


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPieChart(!showPieChart)
    }, 300);

    // Cleanup the timer if the component is unmounted before the timeout completes
    return () => clearTimeout(timer);
  }, []);



  const accordionKeys = ["1", "2", "3", "4", "5"];

  const pieChartData = {
    labels: ["Govt", "Private", "Charitable", "Redcross"],
    datasets: [
      {
        data: [
          totalBloodCentresGovt || 0,
          totalBloodCentresPrivate || 0,
          totalBloodCentresChar || 0,
          totalBloodCentresRedcross || 0,
        ],
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
      },
    ],
  };

  const pieChartDataActive = {
    labels: ["Govt", "Private", "Charitable", "Redcross"],
    datasets: [
      {
        data: [
          totalActiveGovt || 0,
          totalActivePrivate || 0,
          totalActiveChar || 0,
          totalActiveRedcross || 0,
        ],
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
      },
    ],
  };

  const pieChartDataLicensed = {
    labels: ["Govt", "Private", "Charitable", "Redcross"],
    datasets: [
      {
        data: [
          totalLicensedGovt || 0,
          totalLicensedPrivate || 0,
          totalLicensedChar || 0,
          totalLicensedRedcross || 0,
        ],
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
      },
    ],
  };

  const pieChartDataExpired = {
    labels: ["Govt", "Private", "Charitable", "Redcross"],
    datasets: [
      {
        data: [
          totalLicensedExpiredGovt || 0,
          totalLicensedExpiredPrivate || 0,
          totalLicensedExpiredChar || 0,
          totalLicensedExpiredRedcross || 0,
        ],
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
      },
    ],
  };

  const pieChartDataBsu = {
    labels: ["Govt", "Other"],
    datasets: [
      {
        data: [totalBsuGovt || 0, totalBsuOther || 0],
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
        hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"],
      },
    ],
  };

  const pieOptions = {
    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        labels: {
          boxWidth: 16,
          boxHeight: 16,
          font: {
            size: 10,
            weight: "bold",
          },
        },
      },
    },
  };




  
  const barChartData = {
    labels: [
      "AB- ve",
      "AB+ ve",
      "A- ve",
      "A+ ve",
      "B- ve",
      "B+ ve",
      "Oh- ve",
      "Oh+ ve",
      "O- ve",
      "O+ ve",
    ],
    datasets: [
      {
        label: "Blood Availability Today",
        data: [hbnumTotalABneg,hbnumTotalABpos,hbnumTotalAneg,hbnumTotalApos,hbnumTotalBneg,hbnumTotalBpos,hbnumTotalOHneg,hbnumTotalOHpos,hbnumTotalOneg,hbnumTotalOpos],
        backgroundColor: "#50C0FF",
        borderWidth: 0,
      },
    ],
  };

  // const totalCount = data.reduce((total, currentValue) => total + currentValue, 0);

  console.log("Total count", hbnumTotalABneg+hbnumTotalABpos+hbnumTotalAneg+hbnumTotalApos+hbnumTotalBneg+hbnumTotalBpos+hbnumTotalOHneg+hbnumTotalOHpos+hbnumTotalOneg+hbnumTotalOpos)

  const TotalCountBlood = [hbnumTotalABneg+hbnumTotalABpos+hbnumTotalAneg+hbnumTotalApos+hbnumTotalBneg+hbnumTotalBpos+hbnumTotalOHneg+hbnumTotalOHpos+hbnumTotalOneg+hbnumTotalOpos]
//*********************************************************************************************************** */




  const barChartDataTwo = {
    labels: [
      "Whole Blood",
      "Packed Red Blood Cells",
      "Fresh Frozen Plasma",
      "Plasma",
      "Platlet Concentrate",
      "Cryoprecipitate",
      "Cryo Poor Plasma",
      "Single Donor Platelet",
      ,
    ],
    datasets: [
      {
        label: "Component Wise Blood Availability",
        data: [ totalWb,totalPrbc, totalFfp, plasma, totalPlatelateConc, totalCryo, totalCpp, totalSdp],
        backgroundColor: "#50C0FF",
        borderWidth: 0,
      },
    ],
  };


  console.log("total component count ", totalWb+totalPrbc+totalFfp+plasma+totalPlatelateConc+totalCryo+totalCpp+totalSdp)
  const CompCount = [totalWb+totalPrbc+totalFfp+plasma+totalPlatelateConc+totalCryo+totalCpp+totalSdp]



  //************Donor Registered********************************************************************************************************* */



  const districtNamesDonor = [];
  const bloodCentresDataDonor = [];
  const stateNamesDonor = [];
  
  data?.todayStatsData?.todayStatsDonorData ?.forEach(stat => {
    if (scode === 0) {
      stateNamesDonor.push(stat.stateName);
      districtNamesDonor.push(stat.stateName); 
    } else {
      districtNamesDonor.push(stat.districtName); // Use districtName for labels
    }
    bloodCentresDataDonor.push(stat.hbnumDonorRegistered || 0);
  });
  

  const labelsDonor = scode === 0 ? stateNamesDonor : districtNamesDonor;
  const sumDonorRegistered = bloodCentresDataDonor.reduce((acc, val) => acc + val, 0);

  console.log("donor count : ", sumDonorRegistered)

  const barChartDataThree = {
    labels: labelsDonor,
    datasets: [
      {
        label: "Total Donor Registered State Wise",
        data: bloodCentresDataDonor,
        backgroundColor: "#50C0FF",
       
      },
    ],
  };
  
 
  const labelsCount = barChartDataThree.labels.length;
  const baseHeightDonor = labelsCount < 10 ? 50 : labelsCount < 20 ? 50 : 50;
  const heightPerDataPointDonor = 25; // Additional height per data point
  const minHeightDonor = 100; 
  
  let requiredHeightDonor = baseHeightDonor + (labelsCount * heightPerDataPointDonor);
  
  if (labelsCount < 3) {
    requiredHeightDonor = minHeightDonor;
  }
  



  //************************************************************************************************************************************ */


  const splitLabel = (label, maxLength) => {
    if (!label || typeof label !== 'string') {
      return ['Unknown']; // or return [] to avoid adding 'Unknown'
    }
  
    const words = label.split(' ');
    const lines = [];
    let currentLine = words[0];
  
    for (let i = 1; i < words.length; i++) {
      if (currentLine.length + words[i].length + 1 <= maxLength) {
        currentLine += ` ${words[i]}`;
      } else {
        lines.push(currentLine);
        currentLine = words[i];
      }
    }
    lines.push(currentLine);
    return lines;
  };
  
  
  const [sortConfig, setSortConfig] = useState({ key: 'count', direction: 'desc' });
  const [activeSort, setActiveSort] = useState({ key: '', direction: '' });

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
    setActiveSort({ key, direction });
  };

  const sortedData = useMemo(() => {
    const sortableItems = Array.isArray(data?.stateWiseStatsData) ? [...data.stateWiseStatsData] : [];

    if (sortConfig.key === 'count') {
      sortableItems.sort((a, b) => {
        const countA = a.hbnumTotalBloodCentres || 0;
        const countB = b.hbnumTotalBloodCentres || 0;
        return sortConfig.direction === 'asc' ? countA - countB : countB - countA;
      });
    } 
    else if (sortConfig.key === 'state') {
      if (scode === 0) {
        sortableItems.sort((a, b) => {
          const stateA = a.stateName.toLowerCase();
          const stateB = b.stateName.toLowerCase();
          return sortConfig.direction === 'asc' ? stateA.localeCompare(stateB) : stateB.localeCompare(stateA);
        });
      } else {
        sortableItems.sort((a, b) => {
          const districtA = a.districtName?.toLowerCase() || '';
          const districtB = b.districtName?.toLowerCase() || '';
          return sortConfig.direction === 'asc' ? districtA.localeCompare(districtB) : districtB.localeCompare(districtA);
        });
      }
    }

    return sortableItems;
  }, [data?.stateWiseStatsData, sortConfig]);

  const districtNames = [];
  const bloodCentresData = [];
  const stateNames = [];

  sortedData.forEach(stat => {
    if (scode === 0) {
      stateNames.push(splitLabel(stat.stateName, 14)); // Split state names
      districtNames.push(splitLabel(stat.stateName, 14)); 
      bloodCentresData.push(stat.hbnumTotalBloodCentres || 0);
    } else if (stat.districtName) {
      districtNames.push(splitLabel(stat.districtName, 14));    
      bloodCentresData.push(stat.hbnumTotalBloodCentres || 0);
    }
  });

  const labels = scode === 0 ? stateNames : districtNames;

  const barChartDataBlood = {
    labels: labels,
    datasets: [
      {
        label: "Total Blood centres",
        data: bloodCentresData,
        backgroundColor: "#50C0FF",
        borderWidth: 0,
      },
    ],
  };
 
  

  
  console.log(barChartDataBlood);

  const labelsCountTotol = barChartDataBlood.labels.length;
  const baseHeightTotol = labelsCountTotol < 10 ? 50 : labelsCountTotol < 20 ? 50 : 50;
  const heightPerDataPointTotol = 30; // Additional height per data point
  const minHeightTotol = 100;
  
  let requiredHeightTotol = baseHeightTotol + (labelsCountTotol * heightPerDataPointTotol);
  
  if (labelsCountTotol < 3) {
    requiredHeightTotol = minHeightTotol;
  }
  

//********active data ************************************************************ */
const [sortConfigActive, setSortConfigActive] = useState({ key: 'count', direction: 'desc' });
const [activeSortActive, setActiveSortActive] = useState({ key: '', direction: '' });

const handleSortActive = (key) => {
  let direction = 'asc';
  if (sortConfigActive.key === key && sortConfigActive.direction === 'asc') {
    direction = 'desc';
  }
  setSortConfigActive({ key, direction });
  setActiveSortActive({ key, direction });
};

const sortedDataActive = useMemo(() => {
  const sortableItems = Array.isArray(data?.stateWiseStatsData) ? [...data.stateWiseStatsData] : [];

  if (sortConfigActive.key === 'count') {
    sortableItems.sort((a, b) => {
      const countA = a.hbnumTotalActive || 0;
      const countB = b.hbnumTotalActive || 0;
      return sortConfigActive.direction === 'asc' ? countA - countB : countB - countA;
    });
  } else if (sortConfigActive.key === 'state') {
    if (scode === 0) {
      sortableItems.sort((a, b) => {
        const stateA = a.stateName.toLowerCase();
        const stateB = b.stateName.toLowerCase();
        return sortConfigActive.direction === 'asc' ? stateA.localeCompare(stateB) : stateB.localeCompare(stateA);
      });
    } else {
      sortableItems.sort((a, b) => {
        const districtA = a.districtName?.toLowerCase() || '';
        const districtB = b.districtName?.toLowerCase() || '';
        return sortConfigActive.direction === 'asc' ? districtA.localeCompare(districtB) : districtB.localeCompare(districtA);
      });
    }
  }

  return sortableItems;
}, [data?.stateWiseStatsData, sortConfigActive]);


const districtNamesActive = [];
const bloodCentresDataActive = [];
const stateNamesActive = [];

sortedDataActive.forEach(stat => {
  if (scode === 0) {
    stateNamesActive.push(splitLabel(stat.stateName, 14)); // Split state names
    districtNamesActive.push(splitLabel(stat.stateName, 14));   
    bloodCentresDataActive.push(stat.hbnumTotalActive || 0);
  } else if (stat.districtName) {
    districtNamesActive.push(splitLabel(stat.districtName, 14));    
    bloodCentresDataActive.push(stat.hbnumTotalActive || 0);
  }
});

// Determine the labels based on scode
const labelsActive = scode === 0 ? stateNamesActive : districtNamesActive;

// Constructing the bar chart data
const barChartDataActive = {
  labels: labelsActive,
  datasets: [
    {
      label: "Active Blood Centres",
      data: bloodCentresDataActive,
      backgroundColor: "#50C0FF",
      borderWidth: 0,
    },
  ],
};

console.log(barChartDataActive);


const labelsCountActive = barChartDataActive.labels.length;
const baseHeightActive = labelsCountActive < 10 ? 50 : labelsCountActive < 20 ? 50 : 50;
const heightPerDataPointActive = 30; // Additional height per data point
const minHeightActive = 100;

let requiredHeightActive = baseHeightActive + (labelsCountActive * heightPerDataPointActive);

if (labelsCountActive < 3) {
  requiredHeightActive = minHeightActive;
}


//********Licensed Data Blood**************************************************** */

const [sortConfigLic, setSortConfigLic] = useState({ key: 'count', direction: 'desc' });
const [activeSortLic, setActiveSortLic] = useState({ key: '', direction: '' });

const handleSortLic = (key) => {
  let direction = 'asc';
  if (sortConfigLic.key === key && sortConfigLic.direction === 'asc') {
    direction = 'desc';
  }
  setSortConfigLic({ key, direction });
  setActiveSortLic({ key, direction });
};

const sortedDataLic = useMemo(() => {
  const sortableItems = Array.isArray(data?.stateWiseStatsData) ? [...data.stateWiseStatsData] : [];

  if (sortConfigLic.key === 'count') {
    sortableItems.sort((a, b) => {
      const countA = a.hbnumTotalLicensed || 0;
      const countB = b.hbnumTotalLicensed || 0;
      return sortConfigLic.direction === 'asc' ? countA - countB : countB - countA;
    });
  } else if (sortConfigLic.key === 'state') {
    if (scode === 0) {
      sortableItems.sort((a, b) => {
        const stateA = a.stateName.toLowerCase();
        const stateB = b.stateName.toLowerCase();
        return sortConfigLic.direction === 'asc' ? stateA.localeCompare(stateB) : stateB.localeCompare(stateA);
      });
    } else {
      sortableItems.sort((a, b) => {
        const districtA = a.districtName?.toLowerCase() || '';
        const districtB = b.districtName?.toLowerCase() || '';
        return sortConfigLic.direction === 'asc' ? districtA.localeCompare(districtB) : districtB.localeCompare(districtA);
      });
    }
  }

  return sortableItems;
}, [data?.stateWiseStatsData, sortConfigLic, scode]);

const districtNamesLic = [];
const bloodCentresDataLic = [];
const stateNamesLic = [];

sortedDataLic.forEach(stat => {
  if (scode === 0) {
    stateNamesLic.push(splitLabel(stat.stateName, 14)); // Split state names
    districtNamesLic.push(splitLabel(stat.stateName, 14));
    bloodCentresDataLic.push(stat.hbnumTotalLicensed || 0);
  } else if (stat.districtName) {
    districtNamesLic.push(splitLabel(stat.districtName, 14));
    bloodCentresDataLic.push(stat.hbnumTotalLicensed || 0);
  }
});

// Determine the labels based on scode
const labelsLic = scode === 0 ? stateNamesLic : districtNamesLic;

// Constructing the bar chart data
const barChartDataLicense = {
  labels: labelsLic,
  datasets: [
    {
      label: "Licensed Blood Centres",
      data: bloodCentresDataLic,
      backgroundColor: "#50C0FF",
      borderWidth: 0,
    },
  ],
};
console.log(barChartDataLicense);


const labelsCountLic = barChartDataLicense.labels.length;
const baseHeightLic = labelsCountLic < 10 ? 50 : labelsCountLic < 20 ? 50 : 50;
const heightPerDataPointLic = 30; // Additional height per data point
const minHeightLic = 100;

let requiredHeightLic = baseHeightLic + (labelsCountLic * heightPerDataPointLic);

if (labelsCountLic < 3) {
  requiredHeightLic = minHeightLic;
}



//*******Licensed Expired Data Blood **************************************************** */


const [sortConfigLicExp, setSortConfigLicExp] = useState({ key: 'count', direction: 'desc' });
const [activeSortLicExp, setActiveSortLicExp] = useState({ key: '', direction: '' });

const handleSortLicExp = (key) => {
  let direction = 'asc';
  if (sortConfigLicExp.key === key && sortConfigLicExp.direction === 'asc') {
    direction = 'desc';
  }
  setSortConfigLicExp({ key, direction });
  setActiveSortLicExp({ key, direction });
};

const sortedDataLicExp = useMemo(() => {
  const sortableItems = Array.isArray(data?.stateWiseStatsData) ? [...data.stateWiseStatsData] : [];

  if (sortConfigLicExp.key === 'count') {
    sortableItems.sort((a, b) => {
      const countA = a.hbnumTotalLicensedExpired || 0;
      const countB = b.hbnumTotalLicensedExpired || 0;
      return sortConfigLicExp.direction === 'asc' ? countA - countB : countB - countA;
    });
  } else if (sortConfigLicExp.key === 'state') {
    if (scode === 0) {
      sortableItems.sort((a, b) => {
        const stateA = a.stateName.toLowerCase();
        const stateB = b.stateName.toLowerCase();
        return sortConfigLicExp.direction === 'asc' ? stateA.localeCompare(stateB) : stateB.localeCompare(stateA);
      });
    } else {
      sortableItems.sort((a, b) => {
        const districtA = a.districtName?.toLowerCase() || '';
        const districtB = b.districtName?.toLowerCase() || '';
        return sortConfigLicExp.direction === 'asc' ? districtA.localeCompare(districtB) : districtB.localeCompare(districtA);
      });
    }
  }

  return sortableItems;
}, [data?.stateWiseStatsData, sortConfigLicExp, scode]);

const districtNamesLicExp = [];
const bloodCentresDataLicExp = [];
const stateNamesLicExp = [];

sortedDataLicExp.forEach(stat => {
  if (scode === 0) {
    stateNamesLicExp.push(splitLabel(stat.stateName, 14));
    districtNamesLicExp.push(splitLabel(stat.stateName, 14));
    bloodCentresDataLicExp.push(stat.hbnumTotalLicensedExpired || 0);
  } else if (stat.districtName) {
    districtNamesLicExp.push(splitLabel(stat.districtName, 14));
    bloodCentresDataLicExp.push(stat.hbnumTotalLicensedExpired || 0);
  }
});

const labelsLicExp = scode === 0 ? stateNamesLicExp : districtNamesLicExp;

const barChartDataLicensex = {
  labels: labelsLicExp,
  datasets: [
    {
      label: "Licensed Expired Blood Centres",
      data: bloodCentresDataLicExp,
      backgroundColor: "#50C0FF",
      borderWidth: 0,
    },
  ],
};

console.log(barChartDataLicensex);


const labelsCountExp = barChartDataLicensex.labels.length;
const baseHeightExp = labelsCountExp < 10 ? 50 : labelsCountExp < 20 ? 50 : 50;
const heightPerDataPointExp = 30; // Additional height per data point
const minHeightExp = 100;

let requiredHeightExp = baseHeightExp + (labelsCountExp * heightPerDataPointExp);

if (labelsCountExp < 3) {
  requiredHeightExp = minHeightExp;
}


//***********Total BSU**************************************************************************** */
const [sortConfigBsu, setSortConfigBsu] = useState({ key: 'count', direction: 'desc' });
const [activeSortBsu, setActiveSortBsu] = useState({ key: '', direction: '' });

const handleSortBsu = (key) => {
  let direction = 'asc';
  if (sortConfigBsu.key === key && sortConfigBsu.direction === 'asc') {
    direction = 'desc';
  }
  setSortConfigBsu({ key, direction });
  setActiveSortBsu({ key, direction });
};

const sortedDataBsu = useMemo(() => {
  const sortableItems = Array.isArray(data?.stateWiseStatsData) ? [...data.stateWiseStatsData] : [];

  if (sortConfigBsu.key === 'count') {
    sortableItems.sort((a, b) => {
      const countA = a.hbnumTotalBsu || 0;
      const countB = b.hbnumTotalBsu || 0;
      return sortConfigBsu.direction === 'asc' ? countA - countB : countB - countA;
    });
  } else if (sortConfigBsu.key === 'state') {
    if (scode === 0) {
      sortableItems.sort((a, b) => {
        const stateA = a.stateName.toLowerCase();
        const stateB = b.stateName.toLowerCase();
        return sortConfigBsu.direction === 'asc' ? stateA.localeCompare(stateB) : stateB.localeCompare(stateA);
      });
    } else {
      sortableItems.sort((a, b) => {
        const districtA = a.districtName?.toLowerCase() || '';
        const districtB = b.districtName?.toLowerCase() || '';
        return sortConfigBsu.direction === 'asc' ? districtA.localeCompare(districtB) : districtB.localeCompare(districtA);
      });
    }
  }

  return sortableItems;
}, [data?.stateWiseStatsData, sortConfigBsu, scode]);

const districtNamesBsu = [];
const bloodCentresDataBsu = [];
const stateNamesBsu = [];

sortedDataBsu.forEach(stat => {
  if (scode === 0) {
    stateNamesBsu.push(splitLabel(stat.stateName, 14));
    districtNamesBsu.push(splitLabel(stat.stateName, 14));
  } else if (stat.districtName) {
    districtNamesBsu.push(splitLabel(stat.districtName, 14));
  }
  bloodCentresDataBsu.push(stat.hbnumTotalBsu || 0);
});

const labelsBsu = scode === 0 ? stateNamesBsu : districtNamesBsu;

const barChartDataBSU = {
  labels: labelsBsu,
  datasets: [
    {
      label: "Blood Storage Units",
      data: bloodCentresDataBsu,
      backgroundColor: "#50C0FF",
      borderWidth: 0,
    },
  ],
};


const labelsCountBSU = barChartDataBSU.labels.length;
const baseHeight = labelsCountBSU < 10 ? 50 : labelsCountBSU < 20 ? 50 : 50;
const heightPerDataPoint = 30; // Additional height per data point
const minHeight = 100;

let requiredHeight = baseHeight + (labelsCountBSU * heightPerDataPoint);

if (labelsCountBSU < 3) {
  requiredHeight = minHeight;
}


console.log(barChartDataBSU);

//*************************************for State and dtsrict wise stats****************************************************************************** */


 

  
const numLabels = barChartData.labels.length;
const maxChartHeight = 50 + numLabels * 30;

const options = {
  responsive: true,
  maintainAspectRatio: false,
  indexAxis: 'y',
  scales: {
    x: {
      grid: {
        display: false
      }
    },
    
    y: {
      grid: {
        display: false
      },
      min: 0,
      max: 100,
      ticks: {
        beginAtZero: true, 
        stepSize: 50,
        autoSkip: false,
        font: {
          size: 12, 
          
        }
       
      },
      display: true,
      position: 'left',
    },
  }, barThickness: 10,
  plugins: {
    datalabels: {
      color: '#71797E',
      anchor: 'end',
      align: 'end',
      formatter: (value, context) => `${value}`, 
      font: {
        
        size:'10px',
        weight: 'bold',
      },
    },
    legend: {
      display: false,
    },
  },
  layout: {
    padding: {
      right: 30, 
      // left:20
   },
  },
  maxHeight: maxChartHeight, 
  datasets: {
    bar: {
      barPercentage: 0.9, 
      categoryPercentage: 1,
    },
  },
};

//******************************For Today’s Stats bar chart style*************************************************** */


const optionsTwo = {
  responsive: true,
  maintainAspectRatio: false,
  indexAxis: 'y',
  scales: {
    x: {
      grid: {
        display: false
      }
    },
    
    y: {

      grid: {
        display: false
      },
      min: 0,
      max: 100,
      ticks: {
        beginAtZero: true, // Y axis starts at 0
        stepSize: 50, // Adjust the step size as needed
        autoSkip: false,
       
      },
      display: true,
      position: 'left',
    },
  }, barThickness: 10,
  plugins: {
    datalabels: {
      color: '#71797E',
      anchor: 'end',
      align: 'end',
      formatter: (value, context) => `${value}`, 
      font: {
        
        size:'10px',
        weight: 'bold',
      },
    },
    legend: {
      display: false,
    },
  },
  layout: {
    padding: {
      right: 60, // Add padding to the right to provide space for labels
      left:20
   },
  },
  maxHeight: maxChartHeight, 
  datasets: {
    bar: {
      barPercentage: 0.9, 
      categoryPercentage: 1,
    },
  },
};




const [arrow, setArrow] = useState('Show');
const mergedArrow = useMemo(() => {
  if (arrow === 'Hide') {
    return false;
  }
  if (arrow === 'Show') {
    return true;
  }
  return {
    pointAtCenter: true,
  };
}, [arrow]);

  return (
    <div className="d-flex flex-column">
      <div>
        <p className="stats mb-1" style={{ color: "#C02300" }}>
          Stats
        </p>
      </div>
      <div className="d-flex gap-3  mb-4 minwP">
        <div className="minw">
          <Collapse
            expandIconPosition="right"
            expandIcon={({ isActive }) =>
              isActive ? <MinusOutlined /> : <PlusOutlined />
            }
            defaultActiveKey={accordionKeys}
            className="accodianHeader"
          >
            <Panel
              onClick={(e) => e.stopPropagation()}
              header={
                <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
                  {" "}
                  Blood Centres{" "}
                  <DownloadOutlined onClick={(e) => e.stopPropagation()} />
                </span>
              }
              key="1"
            >
              <div
                onClick={() => setShowPieChart(!showPieChart)}
                title="Click to Expand/Close"
                style={{ backgroundColor: "#FFF4E5", cursor: "pointer" }}
              >
                <p className="d-flex justify-content-between padd mb-0 statstotal">
                  Total <span>{totalBloodCentres || 0}</span>
                </p>
                <hr className="m-0"></hr>
                <div className="d-flex flex-column">
                  <h6 className="d-flex justify-content-between padd mb-0 stastvalue">
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Govt: {totalBloodCentresGovt || 0}{" "}
                    </span>
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Private: {totalBloodCentresPrivate || 0}
                    </span>
                  </h6>
                  <h6 className="d-flex justify-content-between padd mb-0 stastvalue">
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Charitable: {totalBloodCentresChar || 0}
                    </span>
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Redcross: {totalBloodCentresRedcross || 0}
                    </span>
                  </h6>
                </div>
                {showPieChart && (
                  <>
                    <div className="d-flex justify-content-center align-items-center p-4">
                      <Pie
                        data={pieChartData}
                        style={{ width: "50%" }}
                        options={pieOptions}
                      />
                    </div>
                    {/* <p className="mb-0 minusClosePie">
                      {" "}
                      <UpOutlined
                        onClick={() => setShowPieChart(!showPieChart)}
                      />
                    </p> */}
                  </>
                )}
              </div>
            </Panel>
          </Collapse>
        </div>
        <div className="minw">
          <Collapse
            expandIconPosition="right"
            expandIcon={({ isActive }) =>
              isActive ? <MinusOutlined /> : <PlusOutlined />
            }
            defaultActiveKey={accordionKeys}
            className="accodianHeader"
          >
            <Panel
              header={
              
                   <Tooltip placement="topLeft" title={text} arrow={mergedArrow}>
            <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
                  {" "}
                  Active Blood Centres{" "} 
                  <DownloadOutlined onClick={(e) => e.stopPropagation()} />
                </span>
          </Tooltip>
                  
                
              }
              key="2"
            >
              <div
                onClick={() => setShowPieChart(!showPieChart)}
                title="Click to Expand/Close"
                style={{ backgroundColor: "#F0F7FD", cursor: "pointer" }}
              >
                <p className="d-flex justify-content-between padd mb-0 statstotal">
                  Total <span>{totalActive || 0}</span>
                </p>
                <hr className="m-0"></hr>
                <div className="d-flex flex-column">
                  <h6 className="d-flex justify-content-between padd mb-0 stastvalue">
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Govt: {totalActiveGovt || 0}{" "}
                    </span>
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Private: {totalActivePrivate || 0}
                    </span>
                  </h6>
                  <h6 className="d-flex justify-content-between padd mb-0 stastvalue">
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Charitable: {totalActiveChar || 0}
                    </span>
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Redcross: {totalActiveRedcross || 0}
                    </span>
                  </h6>
                </div>
                {showPieChart && (
                  <>
                    <div className="d-flex justify-content-center align-items-center p-4">
                      <Pie
                        data={pieChartDataActive}
                        style={{ width: "50%" }}
                        options={pieOptions}
                      />
                    </div>
                    {/* <p className="mb-0 minusClosePie">
                      {" "}
                      <UpOutlined
                        onClick={() => setShowPieChart(!showPieChart)}
                      />
                    </p> */}
                  </>
                )}
              </div>
            </Panel>
          </Collapse>
        
        </div>
        <div className="minw">
          <Collapse
            expandIconPosition="right"
            expandIcon={({ isActive }) =>
              isActive ? <MinusOutlined /> : <PlusOutlined />
            }
            defaultActiveKey={accordionKeys}
            className="accodianHeader"
          >
            <Panel
              header={
                <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
                  {" "}
                  Licensed Blood Centres{" "}
                  <DownloadOutlined onClick={(e) => e.stopPropagation()} />
                </span>
              }
              key="3"
            >
              <div
                onClick={() => setShowPieChart(!showPieChart)}
                title="Click to Expand/Close"
                style={{ backgroundColor: "#F4FDF2", cursor: "pointer" }}
              >
                <p className="d-flex justify-content-between padd mb-0 statstotal">
                  Total <span>{totalLicensed || 0}</span>
                </p>
                <hr className="m-0"></hr>
                <div className="d-flex flex-column">
                  <h6 className="d-flex justify-content-between padd mb-0 stastvalue">
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Govt: {totalLicensedGovt || 0}{" "}
                    </span>
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Private: {totalLicensedPrivate || 0}
                    </span>
                  </h6>
                  <h6 className="d-flex justify-content-between padd mb-0 stastvalue">
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Charitable: {totalLicensedChar || 0}
                    </span>
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Redcross: {totalLicensedRedcross || 0}
                    </span>
                  </h6>
                </div>
                {showPieChart && (
                  <>
                    <div className="d-flex justify-content-center align-items-center p-4">
                      <Pie
                        data={pieChartDataLicensed}
                        style={{ width: "50%" }}
                        options={pieOptions}
                      />
                    </div>
                    {/* <p className="mb-0 minusClosePie">
                      {" "}
                      <UpOutlined
                        onClick={() => setShowPieChart(!showPieChart)}
                      />
                    </p> */}
                  </>
                )}
              </div>
            </Panel>
          </Collapse>
        </div>
        {/* <div className="minw">
          <Collapse
            expandIconPosition="right"
            expandIcon={({ isActive }) =>
              isActive ? <MinusOutlined /> : <PlusOutlined />
            }
            defaultActiveKey={accordionKeys}
            className="accodianHeader"
          >
            <Panel
              header={
                <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
                  {" "}
                  License Expired{" "}
                  <DownloadOutlined onClick={(e) => e.stopPropagation()} />
                </span>
              }
              key="4"
            >
              <div
                onClick={() => setShowPieChart(!showPieChart)}
                title="Click to Expand/Close"
                style={{ backgroundColor: "#FFF4E5", cursor: "pointer" }}
              >
                <p className="d-flex justify-content-between padd mb-0 statstotal">
                  Total <span>{totalLicensedExpired || 0}</span>
                </p>
                <hr className="m-0"></hr>
                <div className="d-flex flex-column">
                  <h6 className="d-flex justify-content-between padd mb-0 stastvalue">
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Govt: {totalLicensedExpiredGovt || 0}{" "}
                    </span>
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Private: {totalLicensedExpiredPrivate || 0}
                    </span>
                  </h6>
                  <h6 className="d-flex justify-content-between padd mb-0 stastvalue">
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Charitable: {totalLicensedExpiredChar || 0}
                    </span>
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Redcross: {totalLicensedExpiredRedcross || 0}
                    </span>
                  </h6>
                </div>
                {showPieChart && (
                  <>
                    <div className="d-flex justify-content-center align-items-center p-4">
                      <Pie
                        data={pieChartDataExpired}
                        style={{ width: "50%" }}
                        options={pieOptions}
                      />
                    </div>
                   
                  </>
                )}
              </div>
            </Panel>
          </Collapse>
        </div> */}
        <div className="minw">
          <Collapse
            expandIconPosition="right"
            expandIcon={({ isActive }) =>
              isActive ? <MinusOutlined /> : <PlusOutlined />
            }
            defaultActiveKey={accordionKeys}
            className="accodianHeader"
          >
            <Panel
              header={
                <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
                  BSU <DownloadOutlined onClick={(e) => e.stopPropagation()} />
                </span>
              }
              key="5"
            >
              <div
                onClick={() => setShowPieChart(!showPieChart)}
                title="Click to Expand/Close"
                style={{ backgroundColor: "#F0F7FD", cursor: "pointer" }}
              >
                <p className="d-flex justify-content-between padd mb-0 statstotal">
                  Total <span>{totalBsu || 0}</span>
                </p>
                <hr className="m-0"></hr>
                <div className="d-flex flex-column">
                  <h6 className="d-flex justify-content-between padd mb-0 stastvalue">
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Govt: {totalBsuGovt || 0}{" "}
                    </span>
                    <span onClick={() => setShowPieChart(!showPieChart)}>
                      Other: {totalBsuOther || 0}
                    </span>
                  </h6>
                  <h6 className="d-flex justify-content-between padd mb-0 stastvalue">
                    <span
                      style={{ visibility: "hidden" }}
                      onClick={() => setShowPieChart(!showPieChart)}
                    >
                      .
                    </span>
                    <span
                      style={{ visibility: "hidden" }}
                      onClick={() => setShowPieChart(!showPieChart)}
                    >
                      .
                    </span>
                  </h6>
                </div>
                {showPieChart && (
                  <>
                    <div className="d-flex justify-content-center align-items-center p-4">
                      <Pie
                        data={pieChartDataBsu}
                        style={{ width: "50%" }}
                        options={pieOptions}
                      />
                    </div>
                    {/* <p className="mb-0 minusClosePie">
                      {" "}
                      <UpOutlined
                        onClick={() => setShowPieChart(!showPieChart)}
                      />
                    </p> */}
                  </>
                )}
              </div>
            </Panel>
          </Collapse>
        </div>
      </div>
      <div>
        <p className="stats mb-2" style={{ color: "#C02300" }}>
          Today’s Stats
        </p>
      </div>
      <div className="row mb-4">
        <div className="col-4">
          <div className="">
            <Collapse
              expandIconPosition="right"
              expandIcon={({ isActive }) =>
                isActive ? <MinusOutlined /> : <PlusOutlined />
              }
              defaultActiveKey={accordionKeys}
              className="accodianHeader"
            >
              <Panel
                style={{
                  boxShadow:
                    "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                }}
                header={
                  <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
                    {" "}
                    Today’s Blood Availability{" "}
                    <DownloadOutlined onClick={(e) => e.stopPropagation()} />
                  </span>
                }
                key="2"
              >
                <div>
                  <p className="d-flex justify-content-between padd mb-0 statstotal">
                    Total <span>{TotalCountBlood}</span>
                  </p>
                  <hr className="m-0"></hr>
                  <div style={{ height: "300px" }}>
                    <Bar data={barChartData} options={optionsTwo} />
                  </div>
                </div>
                {/* <div>
                    <p className="mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn" style={{visibility:'hidden'}}>
                      <span>
                        Count <ArrowUpOutlined />
                        <ArrowDownOutlined />
                      </span>
                      <span>
                        State <ArrowUpOutlined />
                        <ArrowDownOutlined />
                      </span>
                    </p>
                  </div> */}
              </Panel>
              
            </Collapse>
          </div>
        </div>
        <div className="col-4">
          <div className="">
            <Collapse
              expandIconPosition="right"
              expandIcon={({ isActive }) =>
                isActive ? <MinusOutlined /> : <PlusOutlined />
              }
              defaultActiveKey={accordionKeys}
              className="accodianHeader"
            >
              <Panel
                header={
                  <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
                    {" "}
                    Today’s Blood Component Availability{" "}
                    <DownloadOutlined onClick={(e) => e.stopPropagation()} />
                  </span>
                }
                key="2"
              >
                <div>
                  <p className="d-flex justify-content-between padd mb-0 statstotal">
                    Total <span>{CompCount}</span>
                  </p>
                  <hr className="m-0"></hr>
                  <div style={{ height: "300px" }}>
                    <Bar data={barChartDataTwo} options={optionsTwo} />
                  </div>
                </div>
                {/* <div>
                    <p className="mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn" style={{visibility:'hidden'}}>
                      <span>
                        Count <ArrowUpOutlined />
                        <ArrowDownOutlined />
                      </span>
                      <span>
                        State <ArrowUpOutlined />
                        <ArrowDownOutlined />
                      </span>
                    </p>
                  </div> */}
              </Panel>
             
            </Collapse>
          </div>
        </div>
        <div className="col-4">
          <div className="">
            <Collapse
              expandIconPosition="right"
              expandIcon={({ isActive }) =>
                isActive ? <MinusOutlined /> : <PlusOutlined />
              }
              defaultActiveKey={accordionKeys}
              className="accodianHeader"
            >
              <Panel
                header={
                  <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
                    {" "}
                    Donor Registered{" "}
                    <DownloadOutlined onClick={(e) => e.stopPropagation()} />
                  </span>
                }
                key="2"
              >
                <div>
                  <p className="d-flex justify-content-between padd mb-0 statstotal">
                    Total <span>{sumDonorRegistered}</span>
                  </p>
                  <hr className="m-0"></hr>

                  <div className="chartScrollBody">
                    <div  >
                      <div style={{ height: `${requiredHeightDonor}px` }} >
                      <div  style={{ height: `${requiredHeightDonor}px` }} >
                      <Bar data={barChartDataThree} options={optionsTwo} /></div> </div>
                    </div>
                  </div>
                </div>
                
              </Panel>
              {/* <div>
                    <p className="mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn">
                      <span>
                        Count <ArrowUpOutlined />
                        <ArrowDownOutlined />
                      </span>
                      <span>
                        State <ArrowUpOutlined />
                        <ArrowDownOutlined />
                      </span>
                    </p>
                  </div> */}
            </Collapse>
          </div>
        </div>
      </div>
      <div>
      <div>
      {scode !== 0 ? (
        <p className="stats mb-2" style={{ color: "#C02300" }}>
          District wise Stats
        </p>
      ) : (
        <p className="stats mb-2" style={{ color: "#C02300" }}>
          Statewise Stats
        </p>
      )}
    </div>
      </div>
      <div style={{width:'97%'}} >
      <div className="d-flex gap-3 minwP mb-4" >
        <div className="minw">
        <Collapse
      expandIconPosition="right"
      expandIcon={({ isActive }) =>
        isActive ? <MinusOutlined /> : <PlusOutlined />
      }
      defaultActiveKey={accordionKeys}
      className="accodianHeader"
    >
      <Panel
        header={
          <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
            {" "}
            Blood Centres
            <DownloadOutlined onClick={(e) => e.stopPropagation()} />
          </span>
        }
        key="2"
      >
        <div className="chartScrollBody">
          <div>
            <div style={{ height: `${requiredHeightTotol}px` }}>
              <div style={{ height: `${requiredHeightTotol}px` }}>
                <Bar
                  data={barChartDataBlood}
                  options={options}
                  style={{ width: "50%", height: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <p className="mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn">
            <span onClick={() => handleSort('count')}>
              Count 
              <ArrowUpOutlined style={{ color: activeSort.key === 'count' && activeSort.direction === 'asc' ? '#07569b' : 'inherit', cursor:'pointer' }} /> 
              <ArrowDownOutlined style={{ color: activeSort.key === 'count' && activeSort.direction === 'desc' ? '#07569b' : 'inherit',  cursor:'pointer' }} />
            </span>
            <span onClick={() => handleSort('state')}>
              State 
              <ArrowUpOutlined style={{ color: activeSort.key === 'state' && activeSort.direction === 'asc' ? '#07569b' : 'inherit',cursor:'pointer' }} /> 
              <ArrowDownOutlined style={{ color: activeSort.key === 'state' && activeSort.direction === 'desc' ? '#07569b' : 'inherit',cursor:'pointer' }} />
            </span>
          </p>
        </div>
      </Panel>
    </Collapse>
        </div>
        <div className="minw">
        <Collapse
  expandIconPosition="right"
  expandIcon={({ isActive }) =>
    isActive ? <MinusOutlined /> : <PlusOutlined />
  }
  defaultActiveKey={accordionKeys}
  className="accodianHeader"
>
  <Panel
    header={
      <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
        {" "}
        Active Blood Centres{" "}
        <DownloadOutlined onClick={(e) => e.stopPropagation()} />
      </span>
    }
    key="2"
  >
    <div className="chartScrollBody">
      <div>
        <div style={{ height: `${requiredHeightActive}px` }}> 
          <div style={{ height: `${requiredHeightActive}px` }}>
            <Bar
              data={barChartDataActive}
              options={options}
              style={{ width: "50%", height: "100%" }}
            />
          </div>
        </div>
      </div>
    </div>
    <div>
      <p className="mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn">
        <span onClick={() => handleSortActive('count')}>
          Count 
          <ArrowUpOutlined style={{ color: activeSortActive.key === 'count' && activeSortActive.direction === 'asc' ? '#07569b' : 'inherit' ,cursor:'pointer' }} /> 
          <ArrowDownOutlined style={{ color: activeSortActive.key === 'count' && activeSortActive.direction === 'desc' ? '#07569b' : 'inherit',cursor:'pointer' }} />
        </span>
        <span onClick={() => handleSortActive('state')}>
          State 
          <ArrowUpOutlined style={{ color: activeSortActive.key === 'state' && activeSortActive.direction === 'asc' ? '#07569b' : 'inherit',cursor:'pointer' }} /> 
          <ArrowDownOutlined style={{ color: activeSortActive.key === 'state' && activeSortActive.direction === 'desc' ? '#07569b' : 'inherit' ,cursor:'pointer'}} />
        </span>
      </p>
    </div>
  </Panel>
</Collapse>

        </div>
        <div className="minw">
        <Collapse
        expandIconPosition="right"
        expandIcon={({ isActive }) =>
          isActive ? <MinusOutlined /> : <PlusOutlined />
        }
        defaultActiveKey={accordionKeys}
        className="accodianHeader"
      >
        <Panel
          header={
            <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
              {" "}
              Licensed Blood Centres{" "}
              <DownloadOutlined onClick={(e) => e.stopPropagation()} />
            </span>
          }
          key="2"
        >
          <div className="chartScrollBody">
            <div>
              <div style={{ height: `${requiredHeightLic}px` }}>
                <div style={{ height: `${requiredHeightLic}px` }}>
                  <Bar
                    data={barChartDataLicense}
                    options={options}
                    style={{ width: "50%", height: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <p className="mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn">
              <span onClick={() => handleSortLic('count')}>
                Count
                <ArrowUpOutlined style={{ color: activeSortLic.key === 'count' && activeSortLic.direction === 'asc' ? '#07569b' : 'inherit',cursor:'pointer' }} />
                <ArrowDownOutlined style={{ color: activeSortLic.key === 'count' && activeSortLic.direction === 'desc' ? '#07569b' : 'inherit',cursor:'pointer' }} />
              </span>
              <span onClick={() => handleSortLic('state')}>
                {scode === 0 ? 'State' : 'District'}
                <ArrowUpOutlined style={{ color: activeSortLic.key === 'state' && activeSortLic.direction === 'asc' ? '#07569b' : 'inherit' ,cursor:'pointer'}} />
                <ArrowDownOutlined style={{ color: activeSortLic.key === 'state' && activeSortLic.direction === 'desc' ? '#07569b' : 'inherit' ,cursor:'pointer'}} />
              </span>
            </p>
          </div>
        </Panel>
      </Collapse>
        </div>
        {/* <div className="minw">
        <Collapse
        expandIconPosition="right"
        expandIcon={({ isActive }) =>
          isActive ? <MinusOutlined /> : <PlusOutlined />
        }
        defaultActiveKey={accordionKeys}
        className="accodianHeader"
      >
        <Panel
          header={
            <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
              {" "}
              Licensed Expired Blood Centres{" "}
              <DownloadOutlined onClick={(e) => e.stopPropagation()} />
            </span>
          }
          key="2"
        >
          <div className="chartScrollBody">
            <div>
              <div style={{ height: `${requiredHeightExp}px` }}>
                <div style={{ height: `${requiredHeightExp}px` }}>
                  <Bar
                    data={barChartDataLicensex}
                    options={options}
                    style={{ width: "50%", height: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <p className="mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn">
              <span onClick={() => handleSortLicExp('count')}>
                Count
                <ArrowUpOutlined style={{ color: activeSortLicExp.key === 'count' && activeSortLicExp.direction === 'asc' ? '#07569b' : 'inherit' ,cursor:'pointer'}} />
                <ArrowDownOutlined style={{ color: activeSortLicExp.key === 'count' && activeSortLicExp.direction === 'desc' ? '#07569b' : 'inherit' ,cursor:'pointer'}} />
              </span>
              <span onClick={() => handleSortLicExp('state')}>
                {scode === 0 ? 'State' : 'District'}
                <ArrowUpOutlined style={{ color: activeSortLicExp.key === 'state' && activeSortLicExp.direction === 'asc' ? '#07569b' : 'inherit' ,cursor:'pointer'}} />
                <ArrowDownOutlined style={{ color: activeSortLicExp.key === 'state' && activeSortLicExp.direction === 'desc' ? '#07569b' : 'inherit' ,cursor:'pointer'}} />
              </span>
            </p>
          </div>
        </Panel>
      </Collapse>
        </div> */}
        <div className="minw">
        <Collapse
        expandIconPosition="right"
        expandIcon={({ isActive }) =>
          isActive ? <MinusOutlined /> : <PlusOutlined />
        }
        defaultActiveKey={accordionKeys}
        className="accodianHeader"
      >
        <Panel
          header={
            <span className="d-flex justify-content-between align-items-center stastHeaderTitlte">
              {" "}
              BSU <DownloadOutlined onClick={(e) => e.stopPropagation()} />
            </span>
          }
          key="2"
        >
          <div className="chartScrollBody">
            <div>
              <div style={{ height: `${requiredHeight}px` }}>
                <div className="InternalBody" style={{ height: `${requiredHeight}px` }}>
                  <Bar
                    data={barChartDataBSU}
                    options={options}
                    style={{ width: "50%", height: "100%" }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <p className="mb-0 d-flex gap-3 align-items-center justify-content-end filtersbtn">
              <span onClick={() => handleSortBsu('count')}>
                Count
                <ArrowUpOutlined style={{ color: activeSortBsu.key === 'count' && activeSortBsu.direction === 'asc' ? '#07569b' : 'inherit' ,cursor:'pointer'}} />
                <ArrowDownOutlined style={{ color: activeSortBsu.key === 'count' && activeSortBsu.direction === 'desc' ? '#07569b' : 'inherit',cursor:'pointer' }} />
              </span>
              <span onClick={() => handleSortBsu('state')}>
                {scode === 0 ? 'State' : 'District'}
                <ArrowUpOutlined style={{ color: activeSortBsu.key === 'state' && activeSortBsu.direction === 'asc' ? '#07569b' : 'inherit' ,cursor:'pointer'}} />
                <ArrowDownOutlined style={{ color: activeSortBsu.key === 'state' && activeSortBsu.direction === 'desc' ? '#07569b' : 'inherit',cursor:'pointer' }} />
              </span>
            </p>
          </div>
        </Panel>
      </Collapse>
        </div>
      </div></div>
    </div>
   );
  });

export default Insights;
